import $ from 'jquery';

export const isBootstrapModalOpen = () => document.body.classList.contains('modal-open');

export function elementVisibleHeight($el) {
	let elH = $el.outerHeight();
	let H = $(window).height();
	let	r = $el[0].getBoundingClientRect(), t = r.top, b = r.bottom;
	return Math.max(0, t > 0 ? Math.min(elH, H - t) : (b < H ? b : H));
}

export function getScrollParent(node) {
	if (node === null) {
		return null;
	}

	const canScroll = node => node && (node.scrollHeight > node.clientHeight || node.scrollWidth > node.clientWidth);

	if (canScroll(node) && !canScroll(node.parentNode)) {
		return node;
	}
	return getScrollParent(node.parentNode);
}
